import Swal from 'sweetalert2'
import 'js-loading-overlay'
import locale from './locale'

const messages = locale.getMessages()

const helpers = {
    t(key) {
        const sessionLocale = window.lang
        let translation = messages[sessionLocale]
        const keys = key.split('.')
        keys.map((k) => {
            translation = translation[k]
        })
        return translation
    },
    showLoading() {
        JsLoadingOverlay.show({spinnerIcon: 'ball-clip-rotate-multiple'})
    },
    hideLoading() {
        JsLoadingOverlay.hide()
    },
    showError(message) {
        Swal.fire({
            title: helpers.t('modals.error.title'),
            text: message,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: helpers.t('buttons.success'),
            customClass:{
                confirmButton:'btn btn-primary btn-sm',
            }

        })
    },

    confirmDeletePost(text,urlRedirect){
        Swal.fire({
            title: helpers.t('modals.confirm_delete.title'),
            html: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: helpers.t('buttons.submit'),
            cancelButtonText: helpers.t('buttons.cancel'),
            customClass:{
                confirmButton:'btn btn-primary btn-sm',
                cancelButton:'btn btn-dark btn-sm'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post(urlRedirect).then(response => {
                    helpers.showLoading()
                    toast.success('Registro borrado correctamente')
                    setTimeout(()=>{
                        location.reload()
                    },1000)
                })
            }
        })
    },

    confirm(text,callback,data=null){
        Swal.fire({
            title: 'Confirma la acción solicitada',
            html: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: helpers.t('buttons.submit'),
            cancelButtonText: helpers.t('buttons.cancel'),
            customClass:{
                confirmButton:'btn btn-primary btn-sm',
                cancelButton:'btn btn-dark btn-sm'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                callback(data)
            }
        })
    },

    showErrorValidation(errors) {
        let message = ''
        Object.keys(errors).map((key) => {
            message += `<p>${errors[key]}</p>`
        })
        Swal.fire({
            title: helpers.t('modals.error.title'),
            html: `<div class="col-xs-12 col-sm-8 offset-sm-2 text-left">${message}</div>`,
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: helpers.t('buttons.success'),
            customClass:{
                confirmButton:'btn btn-primary btn-sm',
            }
        })
    },

    toastSuccess() {
        toast.success(helpers.t('toast.create_success'))
    },
    swalModalHtml(htmlModal){
        Swal.fire({
            html: htmlModal
        })
    },

    setQueryParams (parameters) {
        let next = '?'
        let string = ''
        const keys = Object.keys(parameters)
        keys.map((key) => {
            string += `${next}${key}=${parameters[key]}`
            next = '&'
        })

        return string
    },

}

export default helpers
